/**
 * 담임목사 인사말 페이지
 */

import React from 'react';
import styled from '@emotion/styled';
import { MainLayout } from '../../../../shared/components';
import { theme } from '../../../../shared/styles/theme';
import { mediaQueries } from '../../../../shared/constants/breakpoints';
import { CHURCH_INFO } from '../../data/churchInfo';
import pastorPhoto from '../../../../assets/images/pastor.jpg';

interface PastorInfo {
  name: string;
  greeting: string;
  photoUrl: string;
}

const PageContainer = styled.div`
  max-width: 1000px;
  margin: 0 auto;
  padding: ${theme.spacing.xxxl} ${theme.spacing.lg};

  ${mediaQueries.maxMobile} {
    padding: ${theme.spacing.xl} ${theme.spacing.md};
  }
`;

const PageTitle = styled.h1`
  font-size: ${theme.fontSizes.xxxl};
  font-weight: 700;
  color: ${theme.colors.primary};
  text-align: center;
  margin-bottom: ${theme.spacing.xxxl};
  font-family: ${theme.fonts.heading};

  ${mediaQueries.maxMobile} {
    font-size: ${theme.fontSizes.xxl};
  }
`;

const ContentSection = styled.div`
  display: grid;
  grid-template-columns: 300px 1fr;
  gap: ${theme.spacing.xxxl};
  align-items: start;

  ${mediaQueries.maxTablet} {
    grid-template-columns: 1fr;
    gap: ${theme.spacing.xl};
  }
`;

const PastorPhotoWrapper = styled.div`
  ${mediaQueries.maxTablet} {
    display: flex;
    justify-content: center;
  }
`;

const PastorPhoto = styled.img`
  width: 300px;
  height: 375px;
  object-fit: cover;
  border-radius: ${theme.borderRadius.lg};
  box-shadow: ${theme.shadows.lg};

  ${mediaQueries.maxMobile} {
    width: 250px;
    height: 312px;
  }
`;

const GreetingContent = styled.div``;

const PastorName = styled.h2`
  font-size: ${theme.fontSizes.xxl};
  font-weight: 700;
  color: ${theme.colors.primary};
  margin-bottom: ${theme.spacing.sm};
  font-family: ${theme.fonts.heading};

  ${mediaQueries.maxMobile} {
    font-size: ${theme.fontSizes.xl};
    text-align: center;
  }
`;

const PastorTitle = styled.p`
  font-size: ${theme.fontSizes.lg};
  color: ${theme.colors.secondary};
  margin-bottom: ${theme.spacing.xl};
  font-weight: 600;

  ${mediaQueries.maxMobile} {
    text-align: center;
  }
`;

const GreetingText = styled.p`
  font-size: ${theme.fontSizes.lg};
  line-height: 2;
  color: ${theme.colors.text};
  white-space: pre-wrap;
  background-color: ${theme.colors.hover};
  padding: ${theme.spacing.xxl};
  border-radius: ${theme.borderRadius.lg};
  border-left: 4px solid ${theme.colors.primary};

  ${mediaQueries.maxMobile} {
    font-size: ${theme.fontSizes.md};
    padding: ${theme.spacing.xl} ${theme.spacing.lg};
  }
`;

const Signature = styled.div`
  text-align: right;
  margin-top: ${theme.spacing.xl};
  font-size: ${theme.fontSizes.lg};
  color: ${theme.colors.primary};
  font-weight: 700;
  font-family: ${theme.fonts.heading};

  ${mediaQueries.maxMobile} {
    font-size: ${theme.fontSizes.md};
  }
`;

export const Greeting: React.FC = () => {
  const pastorInfo = CHURCH_INFO.pastor;

  return (
    <MainLayout>
      <PageContainer>
        <PageTitle>인사의 말</PageTitle>

        <ContentSection>
          <PastorPhotoWrapper>
            <PastorPhoto src={pastorPhoto} alt={`${pastorInfo.name} 목사`} />
          </PastorPhotoWrapper>

          <GreetingContent>
            <PastorName>{pastorInfo.name} 목사</PastorName>
            <PastorTitle>위례세움교회 담임목사</PastorTitle>
            <GreetingText>{pastorInfo.greeting}</GreetingText>
            <Signature>담임목사 {pastorInfo.name}</Signature>
          </GreetingContent>
        </ContentSection>
      </PageContainer>
    </MainLayout>
  );
};
